let dragType: string;

let dropEffect: string;

export interface DragData {
    itemType: string;
}

// We are currently just storing the dragType and dropEffect for IE/Edge scenarios
// For dragType, They do not support custom MIME types, so we do this so we can highlight droppable targets to the user.
// For dropEffect, There is a bug where ondragend's dropEffect is always set to 'none', so we set it manually.
export function setDragType(type: string): void {
    dragType = type;
}

export function getDragType(): string {
    return dragType;
}

export function setDropEffect(effect: string): void {
    dropEffect = effect;
}

export function getDropEffect(): string {
    return dropEffect;
}
